import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banche',
  templateUrl: './banche.component.html',
  styleUrls: ['./banche.component.css']
})
export class BancheComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
